exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.weui-tabbar {\n  position: fixed !important;\n  background-color: #fff !important;\n  box-shadow: 0 0 5px 0 #D6DDE3;\n}\n.weui-tabbar::before {\n  display: none;\n}\n.weui-tabbar .weui-tabbar__icon {\n  width: 22px !important;\n  height: 22px !important;\n}\n.weui-tabbar .weui-tabbar__icon i {\n  font-size: 0.18rem;\n}\n.weui-tabbar .weui-tabbar__icon {\n  margin-bottom: 2px;\n}\n.weui-tabbar .weui-tabbar__label span {\n  font-size: 0.1rem;\n  -webkit-transform: scale(0.83);\n          transform: scale(0.83);\n  display: block;\n}\n", ""]);

// exports
